export const errorActions = {
    REQUEST_CANCELATION_ERROR: 'REQUEST_CANCELATION_ERROR',
    CRITICAL_ERROR: 'CRITICAL_ERROR',
    ERROR_RESET: 'ERROR_RESET',
};
